import { useState, useEffect } from "react";

/**
 * Returns the current network status and exposes a flag that flips
 * when the browser detects an online / offline transition.
 *
 * Usage:
 *   const { isOnline } = useNetworkStatus();
 */
export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return { isOnline };
}
